import { AllFilterTypeConditions } from '@nirvana/shared/dtos/types/shared/filters';
import { FilterConfig } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

export interface FilterConfigFrontend extends FilterConfig {
  filterResetValue?: any;
  apiType?: any;
}

export enum FilterBarEvents {
  FILTERS_CHANGE = 'filtersChanged',
}

export interface UnifiedFilterConfig extends FilterConfigFrontend {
  value?: AllFilterTypeConditions;
}

export const FILTER_LIMIT_FOR_ADD_MORE = 4;
